import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { FileManager } from '../utils/files/file-manager';

export function fileExtensionValidator(allowedExtensions: string[]): ValidatorFn {

    const fileManager = new FileManager(allowedExtensions);

    return (control: AbstractControl): FileExtensionValidation | null => {
        if (control.value === null ) {
            return null;
        }
        if (!fileManager.isAllowedFileExtension(control.value)) {
            return { fileExtension: true };
        }

        return null;
    };
}

export interface FileExtensionValidation extends ValidationErrors {
    fileExtension: boolean;
}

